interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const WarningCircleFileIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_528_8792)">
      <path
        d="M4.75 16C7.07622 16 8.96875 14.1075 8.96875 11.7812C8.96875 9.45503 7.07622 7.5625 4.75 7.5625C2.42378 7.5625 0.53125 9.45503 0.53125 11.7812C0.53125 14.1075 2.42378 16 4.75 16ZM4.28125 9.59375C4.28125 9.33488 4.49113 9.125 4.75 9.125C5.00887 9.125 5.21875 9.33488 5.21875 9.59375L5.21875 12.4062C5.21875 12.6651 5.00887 12.875 4.75 12.875C4.49113 12.875 4.28125 12.6651 4.28125 12.4062L4.28125 9.59375ZM4.75 13.5C5.00887 13.5 5.21875 13.7099 5.21875 13.9688C5.21875 14.2276 5.00887 14.4375 4.75 14.4375C4.49113 14.4375 4.28125 14.2276 4.28125 13.9688C4.28125 13.7099 4.49113 13.5 4.75 13.5Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M13.3438 0.274414V3.12495H16.1941L13.3438 0.274414Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M12.875 4.0625C12.6161 4.0625 12.4062 3.85262 12.4062 3.59375V0H5.6875C4.91209 0 4.28125 0.630844 4.28125 1.40625V6.64653C4.43569 6.63253 4.59197 6.625 4.75 6.625C6.34775 6.625 7.77803 7.3555 8.72456 8.5H13.8125C14.0714 8.5 14.2812 8.70988 14.2812 8.96875C14.2812 9.22762 14.0714 9.4375 13.8125 9.4375H9.34212C9.63513 10.0092 9.82406 10.6427 9.88472 11.3125H13.8125C14.0714 11.3125 14.2812 11.5224 14.2812 11.7812C14.2812 12.0401 14.0714 12.25 13.8125 12.25H9.88472C9.74453 13.7981 8.91741 15.1508 7.71119 16H15.0625C15.8379 16 16.4688 15.3692 16.4688 14.5938V4.0625H12.875ZM13.8125 6.625H6.9375C6.67863 6.625 6.46875 6.41512 6.46875 6.15625C6.46875 5.89738 6.67863 5.6875 6.9375 5.6875H13.8125C14.0714 5.6875 14.2812 5.89738 14.2812 6.15625C14.2812 6.41512 14.0714 6.625 13.8125 6.625Z"
        fill={color}
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_528_8792">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WarningCircleFileIcon;
